import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import axios from "axios";
import {  Link, useNavigate } from 'react-router-dom'
import banner from '../../../images/banners/login.jpg'
import loading from '../../../images/spin.gif'

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export default function Wallet_users() {

  const adminno = sessionStorage.getItem('adminno')
  const navigate=useNavigate()
  if(adminno == 0 || adminno == '' || !adminno){
    navigate('/wallet-dashboard/signin/')
  }

  //console.log(adminno)
  
function walletDashboard_logout(){
  sessionStorage.removeItem('adminno')
 // alert("user logged out successfully");//
  navigate('/wallet-dashboard/signin/')
}


  const API_PATH = `${SERVER_URL}walletusers.php`; 
  //const API_PATH = "http://localhost:8000/walletusers.php"; 
  const [orders, setorders] = useState('')
  const [ordercount, setordercount] = useState(0)
  const [data, setdata2] = useState([])
  const [isload, setisload] = useState(true)
  useEffect(() => {

      axios({
        method: 'post',
        url: `${API_PATH}`
      })
        .then((res) => {
          setisload(false)
          setordercount(res.data.length)
          setdata2(res.data)
           setorders(JSON.parse(JSON.stringify(res.data)))
         
        }
        )
        .catch((err) => console.log(err))
  
    }, [])
  
  const columns = [
     
      {
        name: "id",
        selector: "id",
        sortable: true
       
      },
      {
          name: "user_id",
          selector: "user_id",
          sortable: true,
          cell: (d) => (
            <a onClick={()=>getWallet(d.user_id)} target="_blank" className="dlink">
              {d.user_id}
            </a>
          )
        }
        ,
      {
          name: "display_name",
          selector: "display_name",
          sortable: true
        }
        ,
      {
          name: "user_email",
          selector: "user_email",
          sortable: true
        }
        ,
      {
        name: "my_wallet",
        selector: "my_wallet",
        sortable: true
      }
        ,
      {
        name: "Transaction",
        sortable: false,
        selector: "null",
        cell: (d) => [
            <a onClick={()=>getTransactionIn(d.user_id)} target="_blank" className="dlink" style={{backgroundColor: "#7f3e98", color: "#fff", padding: "2px 4px", borderRadius: "2px", marginRight: "8px" }}>
              Top In
            </a>,
            <a onClick={()=>getTransactionOut(d.user_id)} target="_blank" className="dlink" style={{backgroundColor: "#7f3e98", color: "#fff", padding: "2px 4px", borderRadius: "2px", marginRight: "0px" }}>
              Top Out
            </a>
        ]
      }
    ];
    const tableData = {
      columns,
      data
    };


   function getWallet(val){
    window.open('/wallet/'+val, 'noopener,noreferrer');
  
  // navigate('/track/'+val)
  }

   function getTransactionIn(val){
    window.open('/wallet-user-topin/?type=topin&code='+val, 'noopener,noreferrer');
  }

   function getTransactionOut(val){
    window.open('/wallet-user-topout/?type=topout&code='+val, 'noopener,noreferrer');
  }
 
  return (
    <div>
       <section className="your_business_page fw" style={{ backgroundImage:  `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
              <div className="container"><div className="row">
                    <div className="col-md-12 col-sm-12 your_business text-center">
                        <div className="business_content">
                            <h2>Wallet Users</h2>
                            <p><a className="" style={{cursor: "pointer", textDecoration: "underline"}} onClick={walletDashboard_logout}>- Logout -</a></p>
                           
                        </div>
                    </div>
                </div>
                </div>
            </section>
        <div className="pages_content">
            <div className="container">
            <div className="row">
            <div id="primary" className="content-area" style={{float: 'left', width: '100%'}}>
            <main id="main" className="site-main" role="main">
           <div className="entry-content">
           <div className="become_driver">
           {isload?(
  <div style={{textAlign:"center"}}>
  <p style={{textAlign:"center"}}>Please wait. The data is loading ! </p>
  <img src={loading} alt="" style={{width:"4%"}}  />
  </div>
):(<DataTableExtensions {...tableData}>
  <DataTable
    columns={columns}
    data={data}
    noHeader
    defaultSortField="id"
    // sortIcon={<SortIcon />}
    defaultSortAsc={true}
    pagination
    highlightOnHover
    dense
  />
</DataTableExtensions>
)}
             </div>


            </div>
            </main>
            </div>
            </div>
            </div>
            </div>
    </div>
  )
}
